import Watermark from './Watermark.vue'

Watermark.install = (Vue) => {
    Vue.component(Watermark.name, Watermark)
}

export default Watermark
